import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component
export default class EpicFeatureCard extends Vue {
    public title: string = 'EpicFeatureCard';

    @Prop({
        default: {
            icon: 'Icon',
            title: 'Title',
            content: 'Content',
            slogan: 'Slogan',
            link: '/',
        }
    })
    public data: any;

    @Watch('data', { immediate: true, deep: true })
    public onDataInput(val: any, oldVal: any) {
    }

    public navTo() {
        this.$router.push(`${this.data.link}`);
    }
}
